import "setup/polyfills";
import "setup/axios";
import "setup/moment";

import WebpackerReact from "webpacker-react";

import { RegistrationForm, QualityCheck } from "modules/startups";

import CookiesBanner from "modules/shared/components/Cookies/CookiesBanner";

WebpackerReact.setup({
  RegistrationForm,
  QualityCheck,
  CookiesBanner,
});
